import { createFileRoute } from '@tanstack/react-router';

import ConfirmEmailChange from '@/pages/ConfirmEmailChange';

export const Route = createFileRoute('/_app/confirm-email-change/$token')({
  component: ConfirmEmailChange,
});
